module.exports = __webpack_public_path__ + "static/businessPaymentsCoalition-cea2fe077ab0a01d53c1d017c5ac3595.png";